module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAASCAYAAACAa1QyAAAAAXNSR0IArs4c6QAAAMlJREFUKBVjVFMzFvn558f8/wwM+gxYACMDA1AKBv7fZmBlSWX58edHFsP//z4wYXQaSQdISo7xz98qJqBJAugK8fH///vPzwJXwMhYwcTI+ADOR2P8Y/jPx/Dv/yyQMFwTEzPDzge3r1xAUwvngvz+4993sCYmuCgJjFFN0MAa5AEBTxH//jK4KyjrqOOK4x9/f/DB5OCagCm9499/tDQNU4VGMwGVfUATw8tlZGL8yMLBwjENmAlNgZpBmRCYU3ADoOTt/8xM7QDgNjjkrJQ/xgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/mobile-icon.png
// module id = 5xVg
// module chunks = 1